<template>
  <div>
    <!-- Header -->
    <div class="relative flex justify-center items-center">
      <div class="absolute z-30 text-white px-6">
        <h1 class="text-4xl md:text-5xl leading-[50px] md:leading-[60px] font-serif text-center">{{
          $t('services.educational-support.title') }}</h1>
      </div>
      <div class="absolute z-20 inset-0 bg-black opacity-40"></div>
      <nuxt-img sizes="xl:100vw lg:100vw md:100vw sm:100vw xs:100vw" class="object-cover min-h-[400px] w-full md:aspect-[3]" src="/images/services/educational-support-hero.jpg"
        alt="Servizio di Supporto Didattico" />
    </div>

    <!-- Main Content -->
    <div class="container mx-auto px-6 py-12">
      <p class="text-sm md:text-base text-gray-600 mb-12 max-w-4xl">
        {{ $t('services.educational-support.description') }}
      </p>

      <div class="grid md:grid-cols-2 gap-12">
        <div class="bg-white rounded-lg p-8 shadow-lg">
          <h2 class="text-xl md:text-2xl font-serif mb-6">{{ $t('services.educational-support.our-services') }}</h2>
          <ul class="space-y-3 text-sm md:text-base">
            <li class="flex items-center gap-2">
              <Icon name="mdi:check-circle" class="text-green-600 shrink-0" />
              {{ $t('services.educational-support.services-list.individual-study') }}
            </li>
            <li class="flex items-center gap-2">
              <Icon name="mdi:check-circle" class="text-green-600 shrink-0" />
              {{ $t('services.educational-support.services-list.subject-recovery') }}
            </li>
            <li class="flex items-center gap-2">
              <Icon name="mdi:check-circle" class="text-green-600 shrink-0" />
              {{ $t('services.educational-support.services-list.study-methods') }}
            </li>
            <li class="flex items-center gap-2">
              <Icon name="mdi:check-circle" class="text-green-600 shrink-0" />
              {{ $t('services.educational-support.services-list.learning-support') }}
            </li>
          </ul>
          <!--
          <nuxt-img sizes="xl:100vw lg:100vw md:100vw sm:100vw xs:100vw" src="/images/services/educational-support-services.jpg" alt="Servizi Educativi"
            class="mt-8 rounded-lg w-full h-64 object-cover" />-->
        </div>

        <div class="bg-white rounded-lg p-8 shadow-lg">
          <h2 class="text-xl md:text-2xl font-serif mb-6">{{ $t('services.educational-support.school-levels') }}</h2>
          <ul class="space-y-3 text-sm md:text-base">
            <li class="flex items-center gap-2">
              <Icon name="mdi:check-circle" class="text-green-600 shrink-0" />
              {{ $t('services.educational-support.levels-list.primary') }}
            </li>
            <li class="flex items-center gap-2">
              <Icon name="mdi:check-circle" class="text-green-600 shrink-0" />
              {{ $t('services.educational-support.levels-list.middle') }}
            </li>
            <li class="flex items-center gap-2">
              <Icon name="mdi:check-circle" class="text-green-600 shrink-0" />
              {{ $t('services.educational-support.levels-list.high') }}
            </li>
          </ul>
          <!--<nuxt-img sizes="xl:100vw lg:100vw md:100vw sm:100vw xs:100vw" src="/images/services/educational-support-levels.jpg" alt="Livelli Scolastici"
            class="mt-8 rounded-lg w-full h-64 object-cover" />-->
        </div>
      </div>

      <div class="mt-12 p-8 shadow-lg">
        <h2 class="text-xl md:text-2xl font-serif mb-6">{{ $t('services.educational-support.approach.title') }}
        </h2>
        <div class="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <p class="text-sm md:text-base text-gray-600">
              {{ $t('services.educational-support.approach.description') }}
            </p>
          </div>
          <!--<nuxt-img sizes="xl:100vw lg:100vw md:100vw sm:100vw xs:100vw" src="/images/services/educational-support-approach.jpg" alt="Il Nostro Approccio Educativo"
          class="rounded-lg w-full h-64 object-cover" />-->
        </div>
      </div>

      <!-- Contact Section -->
      <div class="bg-gray-100 p-8 rounded-lg mt-12">
        <h2 class="text-2xl font-serif mb-4">{{ $t('services.educational-support.contact.title') }}</h2>
        <p class="mb-6">
          {{ $t('services.educational-support.contact.description') }}
        </p>
        <div class="flex flex-col md:flex-row gap-4">
          <NuxtLink :to="localePath('/contacts')">
            <Button class="bg-green-600 text-white px-6 py-3 w-full xl:w-auto">
              {{ $t('services.educational-support.contact.contact-btn') }}
            </Button>
          </NuxtLink>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
</script>
